import dataProvider from "./providers/DataProvider";

Vue.blueprintRoutes = [
    {
        path: '/blueprint/:blueprintId',
        name: 'blueprint',
        component: {
            props: {
                dataProviderClass: {
                    type: Function,
                    default: dataProvider
                }
            },
            template: '<bp-blueprint  :dataProviderClass="dataProviderClass" :blueprintId="$route.params.blueprintId" :key="$route.params.blueprintId + $route.query.verticalId + $route.query.versionId" :queryParams="$route.query"/>'
        },
        meta: {
            title: "blueprints",
        },
        children: [
            {
                path: 'condition/:breakpointId',
                name: 'blueprint-condition-form',
                components: {
                    childView: {
                        props: ['dataProvider'],
                        template: '<bp-conditions :dataProvider="dataProvider" :breakpointId="$route.params.breakpointId"/>',
                    }
                },
                children: [
                    {
                        path: ':bundle/:definition/:objectId/:relationString?',
                        name: 'blueprint-condition-action-form',
                        meta: {
                            title: "blueprints condition form",
                        },
                        components: {
                            conditionChildview: {
                                props: ['dataProvider'],
                                template: '<bp-settings-form :dataProvider="dataProvider" />'
                            }
                        },
                    }
                ]
            },
            {
                path: 'blueprint-settings/:activeTab/:relationString?',
                name: 'blueprint-settings',
                meta: {
                    title: "Blueprints settings",
                },
                props: true,
                components:{
                    childView:  {
                        props: ['dataProvider'],
                        template: '<bp-blueprint-settings :dataProvider="dataProvider"/>'
                    }
                },
                children: [
                    {
                        path: 'select-headers',
                        name: 'headers-selection',
                        meta: {
                            title: "Blueprints headers selection",
                        },
                        components: {
                            childView: {
                                props: ['headerHandler'],
                                template: '<bp-headers-selection :headerHandler="headerHandler" v-bind="$attrs" v-on="$listeners"/>'
                            }
                        }
                    }
                ]
            },
            {
                path: 'form/:bundle/:definition/:objectId/:relationString?',
                name: 'blueprint-form',
                meta: {
                    title: "Blueprints skin settings form"
                },
                components:{
                    childView: {
                        template: '<bp-editor-form v-on="$listeners"/>',
                    }
                },
            },
            {
                path: ':blockType/:referenceId/:hashId?/:relationString?',
                name: 'blueprint-block-form',
                meta: {
                    title: "Blueprints form",
                    dataProvider: dataProvider
                },
                props: true,
                components: {
                    childView:  {
                        props: ['dataProvider'],
                        template: '<bp-settings-form :dataProvider="dataProvider" v-on="$listeners"/>'
                    }
                },
            },
        ]
    },
    {
        path: '/skin-settings/:blueprintId/:verticalId/:relationString?',
        name: 'blueprint-skin-settings',
        meta: {
            title: "Blueprints skin settings",
            dataProvider: dataProvider
        },
        props: true,
        component:{
            template: '<bp-skin-settings :dataProviderClass="$route.meta.dataProvider" :blueprintId="$route.params.blueprintId" :verticalId="$route.params.verticalId"></bp-skin-settings>'
        }
    }
];
